// extracted by mini-css-extract-plugin
module.exports = {"container":"wQ","hide":"wR","content":"wS","close":"wT","closeIcon":"wU","svgStyles":"wV"};